/**
 * @fileoverview Login Page Constants
 */

// All available seasonal theme class names (excluding default light/dark)
export const SEASONAL_THEMES = [
  'christmas',
  'halloween',
  'ocean',
  'sunset',
  'forest',
  'lavender',
  'rosegold',
  'midnight',
  'autumn',
  'spring',
  'monochrome'
];
